import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * ScrollSlider class.
 * @typedef {{
 *   $refs: {
 *     message: HTMLElement[],
 *     content: HTMLElement[],
 *     mobile: HTMLElement,
 *     device: HTMLElement[],
 *   },
 * }} ScrollSliderConfig
 * @augments {Base<ScrollSliderConfig>}
 */
export default class ScrollSlider extends withBreakpointObserver(Base) {
  /**
   * ScrollSlider config.
   * @returns {object}
   */
  static config = {
    name: 'ScrollSlider',
    refs: ['message[]', 'content[]', 'mobile', 'device[]'],
    options: {
      inactiveBreakpoints: {
        type: String,
        default: 'xxs xs',
      },
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.position = 0;
    this.currentDevice = document.querySelector('.scroll-slider__device--current');
    const observer = new IntersectionObserver(this.checkIntersection.bind(this), {
      threshold: 0.8,
    });

    this.$refs.content.forEach((target) => {
      observer.observe(target);
    });
  }

  /**
   * Check message intersection with mobile
   * @param  {object} entries
   * @returns {void}
   */
  checkIntersection(entries) {
    if (entries[0].isIntersecting) {
      const { indexContent } = entries[0].target.dataset;
      const position = Number.parseInt(indexContent, 10);
      this.activeMessage(position);
      this.activeDevice(position);
    }
  }

  /**
   * Reset style of unused messages
   * @param  {number} position
   * @returns {void}
   */
  resetMessage(position) {
    this.$refs.message.forEach((element, index) => {
      if (index === position - 1) return;
      element.classList.remove('scroll-slider__message-wrapper--current');
    });
  }

  /**
   * Active current Message
   * @param  {number} position
   * @returns {void}
   */
  activeMessage(position) {
    this.resetMessage(position);
    this.$refs.message[position - 1].classList.add('scroll-slider__message-wrapper--current');
    this.$refs.mobile.classList.toggle('variant', position % 2 === 0);
  }

  /**
   * Change device on scroll
   * @param  {number} position
   * @returns {void}
   */
  activeDevice(position) {
    if (this.currentDevice === this.$refs.device[position - 1]) return;

    if (this.position < position) {
      this.currentDevice.classList.add('scroll-slider__device--out');
    }

    this.position = position;

    this.currentDevice.classList.remove('scroll-slider__device--current');
    this.currentDevice = this.$refs.device[position - 1];
    this.currentDevice.classList.add('scroll-slider__device--current');

    if (this.currentDevice.classList.contains('scroll-slider__device--out'))
      this.currentDevice.classList.remove('scroll-slider__device--out');
  }
}
